import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconChevronLeft"><Path fillRule="evenodd" clipRule="evenodd" d="M15.5305 3.46967C15.8234 3.76256 15.8234 4.23744 15.5305 4.53033L8.94473 11.1161C8.45657 11.6043 8.45657 12.3957 8.94473 12.8839L15.5305 19.4697C15.8234 19.7626 15.8234 20.2374 15.5305 20.5303C15.2376 20.8232 14.7628 20.8232 14.4699 20.5303L7.88407 13.9446C6.81013 12.8706 6.81013 11.1294 7.88407 10.0555L14.4699 3.46967C14.7627 3.17678 15.2376 3.17678 15.5305 3.46967Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronLeft;
